var createWishlist_gql_default = `
mutation createGuestWishlist {
  WmCreateWishlist {
    sharing_code
  }
}
`;
export {
  createWishlist_gql_default as default
};
